import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Route, RouteProps, Redirect } from "react-router-dom";
import { checkAuth } from "../../actions/users/users";
import { amRoutes } from "../../config/config";
import { AppDispatch, RootState } from "../../reducers";
import { isPublic } from "../../utils/utils";
import LoginView from "../../views/LoginView";

const mapStateToProps = (state: RootState) => {
  return {
    isAuthenticated: state.users.isAuthenticated,
    isAuthenticating: state.users.isAuthenticating,
    user: state.users.userClaims
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  checkAuth: () => dispatch(checkAuth())
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type PrivateRouteProps = RouteProps & PropsFromRedux & { allowPublic?: boolean };

class PrivateRoute extends React.Component<PrivateRouteProps> {
  constructor(props: PrivateRouteProps) {
    super(props);
    this.props.checkAuth();
  }

  render() {
    if (!this.props.isAuthenticated) return <LoginView />;
    const isAuthorized = !isPublic(this.props.user) || this.props.allowPublic;
    if (!isAuthorized) return <Redirect to={amRoutes.profile} />;
    return <Route {...this.props} />;
  }
}

export default connector(PrivateRoute);
